import {useEffect, useState} from "react";
import {Call} from "../../store/features/calls/callsService";

const format = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    return `${minutes}:${(seconds % 60).toString().padStart(2, "0")}`;
};

/** Live "m:ss" since the call was answered; empty until it is. */
const CallTimer = ({call}: { call: Pick<Call, 'bridgetAt'> }) => {
    const [elapsed, setElapsed] = useState(0);

    useEffect(() => {
        if (!call.bridgetAt) return;
        const start = new Date(call.bridgetAt).getTime();
        const tick = () => setElapsed(Math.max(0, Math.floor((Date.now() - start) / 1000)));
        tick();
        const interval = window.setInterval(tick, 1000);
        return () => window.clearInterval(interval);
    }, [call.bridgetAt]);

    if (!call.bridgetAt) return null;
    return <span className="tabular-nums">{format(elapsed)}</span>;
};

export default CallTimer;
